// SCRUM-116: defaults for IndiaPolls (IN) markets only; every other market
// keeps the existing defaults. The client's wording is kept as given; only
// line breaks and links are HTML, since these fields render as HTML.

// Points disclaimer, shown on the panel's survey outcome pages.
export const IN_DEFAULT_DISCLAIMER = [
  'Dear Respondent,',
  'Thank you for your continued participation with IndiaPolls. Your valuable feedback helps shape the online market research industry.',
  'Your points have been successfully added to your IndiaPolls account. To learn more about your points, surveys, rewards, and other important information, please visit our FAQ section - <a href="https://panel.indiapolls.com/#/faq" target="_blank" style="color: orange;">https://panel.indiapolls.com/#/faq</a>',
  'Thank you for being a valued member of IndiaPolls and for sharing your opinions!',
].join('<br>');

// Invitation email. The IN country backend renders {{points}} (the market's
// Complete Points) and {{topic}} (its survey description) in the subject.
export const IN_TEMPLATE_SUBJECT = 'Earn {{points}} i-Points Instantly - New IndiaPolls Survey on {{topic}}';

// {{surveyLink}} is used as-is: it is already a full URL, never prefix http://.
export const IN_TEMPLATE_BODY = '<p>Dear {{firstName}} {{lastName}},</p>'
  + '<p>We hope this message finds you well.</p>'
  + '<p>You have been invited to participate in our survey! Your feedback is valuable to us, and we appreciate your time in helping us improve our services.</p>'
  + '<p><br></p>'
  + '<p>Survey Details:</p>'
  + '<ul><li>Survey Name: {{surveyName}}</li><li>Survey Description: {{surveyDescription}}</li></ul>'
  + '<p>Click the following link to access the survey: <a href="{{surveyLink}}">Take Survey</a></p>'
  + '<p><br></p>'
  + '<p>Want to earn even more i-Points?</p>'
  + '<p>Invite a friend to join IndiaPolls! For each successful registration through your referral, your account will be credited with 25 i-Points. You can earn up to 250 i-Points by inviting up to 10 people per month.</p>';

// India is "IN" on most survey rows; some only carry the country name.
export const isIndiaMarket = (survey: { shortName?: string; country?: string } | null | undefined): boolean =>
  !!survey && (String(survey.shortName || '').toUpperCase() === 'IN' || survey.country === 'India');
